import * as Format from "./Format";
export default Format;
